import { RegionsPage } from "@/components/non_registrant/regions-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/regions")({
  component: function OperatorRegionsRoute() {
    return <RegionsPage portal="operator" />;
  },
});
